/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PaymentMethodDto } from '../../models/payment-method-dto';

export interface CustomersControllerGetPaymentMethod$Params {
  customerId: string;
}

export function customersControllerGetPaymentMethod(http: HttpClient, rootUrl: string, params: CustomersControllerGetPaymentMethod$Params, context?: HttpContext): Observable<StrictHttpResponse<PaymentMethodDto>> {
  const rb = new RequestBuilder(rootUrl, customersControllerGetPaymentMethod.PATH, 'get');
  if (params) {
    rb.path('customerId', params.customerId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PaymentMethodDto>;
    })
  );
}

customersControllerGetPaymentMethod.PATH = '/keus-payments/customers/{customerId}/payment-method';
